/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rapat_TInputs */

const en_tut_rapat_t = /** @type {(inputs: Tut_Rapat_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating and running a meeting`)
};

const id_tut_rapat_t = /** @type {(inputs: Tut_Rapat_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuat dan menjalankan rapat`)
};

/**
* | output |
* | --- |
* | "Creating and running a meeting" |
*
* @param {Tut_Rapat_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rapat_t = /** @type {((inputs?: Tut_Rapat_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rapat_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rapat_t(inputs)
	return en_tut_rapat_t(inputs)
});